/**************************************************
 * Nombre:       Catalogo
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import {theme} from "../../../../Tema";
import costal from '../../../../Recursos/costal_cafe.png'
import {iniciarChatWass} from "../../../../Utilidades/iniciarChatWass";
import {useResponsive} from "../../../../Modulo_responsive/Hooks/useResponsive";
import {useEffect, useState} from "react";
import {obtenerColWheres} from "../../../../Servicios/BD/obtenerColWheres";
import {where} from "firebase/firestore";
import {useNavigate} from "react-router-dom";


const Catalogo = () => {
    const {sCell, masSM} = useResponsive()
    const navigate = useNavigate();
    const [varietales, setVarietales] = useState([])

    const organizarVarietales = (data) =>{

        //obtenemos todos los origenes
        //filtramos por origenes
        //organizamos por varietal


        let setOrigenes = new Set(data.map((it) => it.origen))
        let origenes = [...setOrigenes]
        let setCategorias = new Set(data.map((it) => it.categoria))
        let categorias = [...setCategorias]


        console.log(origenes)
        console.log(categorias)


        let arr = []
        for (let i = 0 ; i < origenes.length ; i++){
            let arrOrigen = data.filter((it) => it.origen === origenes[i])
            for (let j = 0; j < categorias.length; j++){
                let arrCategoria = arrOrigen.filter((it) => it.categoria === categorias[j])
                arr.push(arrCategoria)
            }
        }

        setVarietales(arr)
        console.log(arr)


    }

    useEffect(() =>{

        let w = [where('estado', '==', 'Publicado')]
        obtenerColWheres({col: 'varietales', wheres: w}).then((dox) =>{
            organizarVarietales(dox.data)
        })

    },[])
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>


            {varietales.map((items) =>{
                return(
                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 16}}>
                        <Grid
                            container
                            justifyContent={'flex-start'}
                            alignItems={'flex-start'}
                            size={{xs: 12, sm: 12, md: 12}}
                            sx={{backgroundColor: theme.palette.primary.main, p: 3, borderRadius: 1}}
                        >

                            <Grid container size={{xs: 12, sm: 3, md: 3}} sx={{justifyContent: 'flex-start'}}>
                                <Grid
                                    container
                                    justifyContent={'flex-start'}
                                    alignItems={'flex-start'}
                                    size={{xs: 12, sm: 12, md: 12}}>

                                    <Grid container size={{xs: 12, sm: 12, md: 12}}
                                          sx={{justifyContent: sCell ? 'center' : 'flex-start'}}>
                                        <Typography sx={{color: '#fff', fontSize: 24, fontWeight: 600, lineHeight: 1.2}}>
                                            {`Origenes ${items[0] ? items[0].origen : ''}`}
                                        </Typography>
                                    </Grid>


                                    <Grid container size={{xs: 12, sm: 12, md: 12}}
                                          sx={{justifyContent: sCell ? 'center' : 'flex-start', mt: sCell ? 4 : 1.6}}>
                                        <Typography sx={{color: '#000', fontWeight: 600, fontSize: 16, lineHeight: 1.2}}>
                                            {`Varietales ${items[0] ? items[0].categoria : ''}`}
                                        </Typography>
                                    </Grid>


                                </Grid>
                            </Grid>

                            <Grid container size={{xs: 12, sm: 9, md: 9}}
                                  sx={{justifyContent: 'flex-start', mt: sCell ? 2 : -14}}>
                                <Grid
                                    container
                                    justifyContent={sCell ? 'center' : 'flex-start'}
                                    alignItems={'flex-start'}
                                    size={{xs: 12, sm: 12, md: 12}}
                                    spacing={sCell ? 2 : 2}
                                >

                                    {items.map((item, i) => (
                                        <Grid container size={{xs: 6, sm: 6, md: 4}} sx={{justifyContent: 'flex-start'}}>
                                            <Grid
                                                container
                                                justifyContent={'flex-start'}
                                                alignItems={'flex-start'}
                                                size={{xs: 12, sm: 12, md: 12}}
                                                spacing={0}
                                            >

                                                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                                                    <img src={item.img ? item.img : costal} width={sCell ? '80%' :
                                                        '90%'} height={'auto'}/>
                                                </Grid>

                                                <Grid container size={{xs: 12, sm: 12, md: 12}}
                                                      sx={{justifyContent: 'center', mt: 2}}>
                                                    <Typography sx={{
                                                        color: '#fff',
                                                        fontWeight: 600,
                                                        fontSize: sCell ? 18 : 16,
                                                        lineHeight: 1.2,
                                                        textAlign: 'center'
                                                    }}>
                                                        {item.nombre}
                                                    </Typography>
                                                </Grid>

                                                <Grid container size={{xs: 12, sm: 12, md: 12}}
                                                      sx={{justifyContent: 'center'}}>
                                                    <Typography sx={{color: '#000'}}>
                                                        {item.region}
                                                    </Typography>
                                                </Grid>

                                                <Grid container size={{xs: 12, sm: 12, md: 12}}
                                                      sx={{justifyContent: 'center', mt: 1}}>
                                                    <Button
                                                        onClick={() => navigate('/Detalle/'+item.id)}
                                                        variant={'outlined'} color={'secondary'}
                                                        sx={{fontSize: 14}}>Ver</Button>
                                                </Grid>

                                            </Grid>
                                        </Grid>
                                    ))}

                                </Grid>
                            </Grid>

                        </Grid>
                    </Grid>
                )
            })}






        </Grid>
    )

}
export default Catalogo

const items1 = [
    {
        nombre: 'Regional Lavado',
        departamento: 'Nariño',
    },
    {
        nombre: 'Regional Natural',
        departamento: 'Nariño',
    },
    {
        nombre: 'Regional Honey',
        departamento: 'Nariño',
    },
]

const items2 = [
    {
        nombre: 'Geisha Lavado',
        departamento: 'Nariño',
    },
    {
        nombre: 'Regional Honey',
        departamento: 'Nariño',
    },
    {
        nombre: 'Papayo Lavado',
        departamento: 'Nariño',
    },
]